import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from "./routes/ProtectedRoute";
import { initialRoutes } from "./routes/routes";

const generateRoutes = (routes) => {
  return routes.map(({ type, component: Component, children, ...rest }) => (
    <Route
      key={rest.path}
      {...rest}
      element={
        <ProtectedRoute type={type} title={rest.title} image={rest.image}>
          <Component />
        </ProtectedRoute>
      }
    >
      {children?.length ? generateRoutes(children) : null}
    </Route>
  ));
};

const App = () => (
  <Routes>{generateRoutes(initialRoutes())}</Routes>
);

export default App;